/* eslint-disable max-len */
import { adrian, anil, chris, mateo, nikky, sujata } from '../assets';

export const clients = [
  {
    name: 'Adrian Hajdin',
    postition: 'Founder and CEO at JavaScript Mastery',
    image: adrian,
    desc: 'Nenad is a fantastic developer who consistently finds unique solutions, optimizes the codebase, and maintains a clean code architecture. His enthusiasm for learning and embracing new challenges is inspiring. Nenad\'s expertise and positive attitude make him a valuable asset to any developer team. I would highly recommend him!',
  },
  {
    name: 'Mateo Sindičić',
    postition: 'Lead Software Engineer and Project Manager',
    image: mateo,
    desc: 'Nenad makes complex problems look simple, his analytical thinking paired with his eye for detail produce stunning results - no questions asked.',
  },
  {
    name: 'Sujata Gunale',
    postition: 'Lead Software Engineer',
    image: sujata,
    desc: 'I strongly recommend Nenad for his outstanding ability to solve problems and approach them with a unique thought process. He is a skilled developer who displays a deep passion for acquiring new knowledge and adapting to emerging technologies.',
  },
  {
    name: 'Christopher Soltis',
    postition: 'Senior Software Enginner',
    image: chris,
    desc: 'Nenad is an exceptional software developer with a unique combination of strength, dedication, and focus. A hard worker, always willing to do whatever it takes to achieve results. His passion for software development is evident in his work, and dedication. He truly has a bright future ahead of him.',
  },
  {
    name: 'Nikky Eya',
    postition: 'Software Enginner',
    image: nikky,
    desc: 'It has been a pleasure working with Nenad, an exceptional software developer who demonstrates responsibility, organization, and passion for his work. He consistently tackles challenging problems and is a valuable asset to our team.',
  },
  {
    name: 'Anil Thapa Magar',
    postition: 'Software Enginner',
    image: anil,
    desc: 'Nenad has a keen eye for aesthetics and can create visually stunning web applications that are both functional and intuitive. His willingness to share his knowledge and expertise with team members has been instrumental in the success of our projects. I feel extremely grateful to have him as a member of our team.',
  },
];
